import { PaymentMethod } from '@features/invoicingSettings/types/paymentMethod'

import { paymentMethodTypeToFormField } from '../constants/paymentMethodTypeToFormField'
import type { DisplayedPaymentMethods } from '../types/invoiceForm/displayedPaymentMethods'

// Narrows the organization's configured payment methods down to the ones enabled on this document.
export const filterDisplayedPaymentMethods = (
  paymentMethods: PaymentMethod[] = [],
  displayedPaymentMethods?: DisplayedPaymentMethods,
): PaymentMethod[] => {
  if (!displayedPaymentMethods) {
    return []
  }

  return paymentMethods.filter(({ type }) => {
    const formField = paymentMethodTypeToFormField[type]

    return formField ? Boolean(displayedPaymentMethods[formField]) : false
  })
}
